export const dateJsonSchema = {
  type: 'object',
  properties: {
    storeID: {
      type: 'string',
      description: 'OD',
    },
    customerName: {
      type: 'string',
    },
    nickname: {
      type: 'string',
    },
    storeName: {
      type: 'string',
    },
    customerUniqId: {
      type: 'string',
    },
    idNumber: {
      type: 'string',
    },
  },
}

export const dateUiSchema = {
  type: 'VerticalLayout',
  className: 'identification-filters',
  elements: [
    {
      type: 'HorizontalLayout',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/storeID',
          component: 'ReadOnlyFieldWithJson',
          label: 'Store ID',
        },
        {
          type: 'Control',
          scope: '#/properties/customerName',
          component: 'ReadOnlyFieldWithJson',
          label: 'Customer Name',
        },
        {
          type: 'Control',
          scope: '#/properties/nickname',
          component: 'ReadOnlyFieldWithJson',
          label: 'Nickname ',
        },
      ],
    },
    {
      type: 'HorizontalLayout',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/storeName',
          component: 'ReadOnlyFieldWithJson',
          label: 'Store Name',
        },
        {
          type: 'Control',
          scope: '#/properties/customerUniqId',
          component: 'ReadOnlyFieldWithJson',
          label: 'Customer Uniq ID',
        },
        {
          type: 'Control',
          scope: '#/properties/idNumber',
          component: 'ReadOnlyFieldWithJson',
          label: 'ID Number',
        },
      ],
    },
  ],
}
